import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "identitasPegawai";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const userGetData = "user/getData/";
export const masterRegion = "Master/Region/list/";
export const masterReligion = "Master/Religion/list/";
export const masterBloodType = "Master/BloodType/list/";
export const masterMaritalStatus = "Master/MaritalStatus/list/";
export const masterBank = "Master/Bank/list/";
export const masterEmployeeType = "Master/EmployeeType/list/";
export const masterEmployeeStatus = "Master/EmployeeStatus/list/";
export const masterEmployeeStatusDescription =
  "Master/EmployeeStatusDescription/list/";
export const masterEmployeeStatusPosition =
  "Master/EmployeeStatusPosition/list/";
export const masterWorkUnit = "Master/WorkUnit/list/";
export const masterGajiwebSatker = "Master/GajiWeb/listSatker/";
export const masterGajiwebBankSpan = "Master/GajiWeb/listBankSpan/";
export const masterEmployee = "Master/GajiWeb/listPegawai/";

export const identitasDetail = "Kepegawaian/Identitas/detail/";
export const identitasUpdate = "Kepegawaian/Identitas/update/";
export const identitasApprove = "Kepegawaian/Identitas/approve/";
export const identitasImages = "Kepegawaian/Identitas/images/";
export const deleteFotoAbsen = "Kepegawaian/Identitas/deleteFotoAbsen/";

export const downloadDRH = "Kepegawaian/DRH/download/";
export const downloadDRHdoc = "Kepegawaian/DRH/downloaddoc/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
